/* Desktop hover support for Shopify details-based navigation. */
(() => {
  const mq = window.matchMedia('(min-width: 990px)');
  let closeTimer;

  const closeOthers = (current) => {
    document.querySelectorAll('.header__inline-menu details[open]').forEach((item) => {
      if (item !== current) item.removeAttribute('open');
    });
  };

  const init = () => {
    document.querySelectorAll('.header__inline-menu details').forEach((details) => {
      if (details.dataset.tdbHoverReady) return;
      details.dataset.tdbHoverReady = 'true';

      details.addEventListener('mouseenter', () => {
        if (!mq.matches) return;
        window.clearTimeout(closeTimer);
        closeOthers(details);
        details.setAttribute('open', '');
      });

      details.addEventListener('mouseleave', () => {
        if (!mq.matches) return;
        closeTimer = window.setTimeout(() => details.removeAttribute('open'), 140);
      });

      details.addEventListener('focusin', () => {
        if (!mq.matches) return;
        window.clearTimeout(closeTimer);
        closeOthers(details);
        details.setAttribute('open', '');
      });

      details.addEventListener('focusout', (event) => {
        if (!mq.matches || details.contains(event.relatedTarget)) return;
        closeTimer = window.setTimeout(() => details.removeAttribute('open'), 100);
      });
    });
  };

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
